//Dummydata:
/*

	Important data for this Notification Center are:
		- created
		- flags
		- sourceIcon
		- sourceName
		- title
		- content
		- dsLoader (handle on click)


*/
const notifi: ISystemNotification[] = [{
	id: FpId.new(),
	msgKey: FpId.new(),
	created: +new Date("Wed Aug 23 2017 18:57:30 GMT+0200 (CEST)"),
	deleted: null,
	dscaid: 12345,
	dscid: 5030,

	flags: 1,
	sourceIcon: "print",
	sourceName: "Print",
	title: "Bookings.pdf",
	content: "generating PDF FIle...",
	htmlContent: null,

	firstRead: null,
	deliveryMethod: SystemNotificationDeliveryMethod.PUSH,
	deliveries: [{
		id: FpId.new(),
		method: SystemNotificationDeliveryMethod.PUSH,
		send: +new Date("Wed Aug 23 2017 01:57:30 GMT+0200 (CEST)"),
		read: null,
	}],

	dsLoader: {
		element: "",
		target: "dsloader",
		url: "/dynasite.cfm`dscmd=mediaapi_mediapi_mediaapi_download&id=12345"
	},
}, {
	id: FpId.new(),
	msgKey: FpId.new(),
	created: +new Date().setHours(new Date().getHours() - 3),
	deleted: null,
	dscaid: 12345,
	dscid: 5030,

	flags: 0,
	sourceIcon: "calendar",
	sourceName: "Advanced Calendar",
	title: "Meeting",
	content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod" +
				" tempor incididunt ut labore et dolore magna aliqua. Cras pulvinar mattis nunc sed blandit libero volutpat.",
	htmlContent: null,

	firstRead: null,
	deliveryMethod: SystemNotificationDeliveryMethod.PUSH,
	deliveries: [{
		id: FpId.new(),
		method: SystemNotificationDeliveryMethod.PUSH,
		send: +new Date(),
		read: null,
	}],

	dsLoader: {
		element: "",
		target: "dsloader",
		url: "/dynasite.cfm`dscmd=mediaapi_mediapi_mediaapi_download&id=12345"
	},
}, {
	id: FpId.new(),
	msgKey: FpId.new(),
	created: +new Date(),
	deleted: null,
	dscaid: 12345,
	dscid: 5030,

	flags: 0,
	sourceIcon: "envelope",
	sourceName: "Messaging",
	title: "You received a message",
	content: "User1 has send you a message",
	htmlContent: null,

	firstRead: null,
	deliveryMethod: SystemNotificationDeliveryMethod.PUSH,
	deliveries: [{
		id: FpId.new(),
		method: SystemNotificationDeliveryMethod.PUSH,
		send: +new Date(),
		read: null,
	}],

	dsLoader: {
		element: "",
		target: "dsloader",
		url: "/dynasite.cfm`dscmd=mediaapi_mediapi_mediaapi_download&id=12345"
	},
}, {
	id: FpId.new(),
	msgKey: FpId.new(),
	created: +new Date(new Date().setMinutes(new Date().getMinutes() - 3)),
	deleted: null,
	dscaid: 12345,
	dscid: 5030,

	flags: 0,
	sourceIcon: "bell",
	sourceName: "Certs and Docs",
	title: "Personalausweis will expire",
	content: "Personalausweis will expire in two days",
	htmlContent: null,

	firstRead: null,
	deliveryMethod: SystemNotificationDeliveryMethod.PUSH,
	deliveries: [{
		id: FpId.new(),
		method: SystemNotificationDeliveryMethod.PUSH,
		send: +new Date(),
		read: null,
	}],

	dsLoader: {
		element: "",
		target: "dsloader",
		url: "/dynasite.cfm`dscmd=mediaapi_mediapi_mediaapi_download&id=12345"
	},
}];




import * as React from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import styles from "./NotificationCenter.scss";
import autobind from "autobind-decorator";
import * as moment from "moment-timezone";
import { ISystemNotification, SystemNotificationDeliveryMethod, SystemNotificationFlags } from "../../lib/api/SystemNotificationApi";
import { FpId } from "../../lib/index";
import { faTimes } from "@fortawesome/fontawesome-pro-light";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
//import { sortBy } from "lodash";

interface INotificationCenterProps {
	handleAmNotifications?: Function;
}

export class NotificationCenter extends React.Component<INotificationCenterProps, any>{
	private intervalId;
	private intervalNotification;
	constructor(props) {
		super(props);
		this.state = {
			data: notifi
		};
	}

	// private updateAmountNotifications = () =>{
	// 	this.props.handleNotifications(this.state.data.length);
	// }

	private sort() {
		// //this.setState({data : sortBy(this.state.data, [function(el) {return el.created; }])});
		let temp = this.state.data;
		temp.sort((x, y) => {
			return y.created - x.created;
		});
		this.setState({data: temp});
	}

	public async componentWillMount() {
		this.sort();
		this.pullNewData();
		this.intervalId = setInterval(() => {this.forceUpdate(); }, 60000); //1min -> Rerender to update time?
		this.intervalNotification = setInterval(() => {this.pullNewData(); }, 1000); //update notifications every second
	}

	public componentWillUnmount() {
		clearInterval(this.intervalId);
		clearInterval(this.intervalNotification);
	}

	@autobind
	private remove(jsonObject) {
		let index = this.state.data.findIndex((el) => {
				return el.id === jsonObject.id;
			});
		this.state.data.splice(index, 1);
		this.sort();
	}

	@autobind
	private async pullNewData() {
		// let data = await fetch(""); //fetch data
		// let jsonNotifications = await data.json();
		// this.setState({}
		// 		data:jsonNotifications,
		// });
		if (this.props.handleAmNotifications) {
			this.props.handleAmNotifications(this.state.data.length); //update notifications
		}
	}

	public render() {
		return(
			<div style={{ display: "flex", flexFlow: "column", height: "100%"}}>
				<div style={{ flex: "1", minHeight: 0, overflow: "auto" }}>
					{this.state.data.length > 0 ?
						this.state.data.map((data) =>
							<Notification key={data.id} data={data} onRead={this.remove}/>
						)
					:
						<div className = {styles.noNotifications}>
							No Notifications
						</div>
					}
				</div>
				<div className={"list-group-item " + " " + styles.showReadNoti}>
					<a href="#">
						Show read Notifications
					</a>
				</div>
			</div>
		);
	}
}


interface INotificationProps {
	data: ISystemNotification;
	onRead: (notification: ISystemNotification) => void;
}

class Notification extends React.Component<INotificationProps, any>{
	constructor(props) {
		super(props);
		this.state = {
			didHover: false,
		};
	}

	@autobind
	private readNotification (e) {
		e.stopPropagation();
		if (this.isReadable()) {
			alert("read notification");
			this.props.onRead(this.props.data);
		}
	}

	@autobind
	private markAsRead (e) {
		e.stopPropagation();
		if (this.isReadable()) {
			alert ("this message will now be marked as read");
			this.props.onRead(this.props.data);
		}
	}

	private isReadable() {
		return (this.props.data.flags & SystemNotificationFlags.NOT_READABLE) === 0;
	}


	/**
	 * returns true, if the message is younger then one minute
	 */
	//computed value?
	private displaAsyNew = () => {
		return ((new Date().getTime() - new Date(this.props.data.created).getTime()) <= 6000) && !this.state.didHover; //1min, 10 sec for testing
	}

	private reactToHover = () => {
		this.setState({
			didHover: true,
		});
	}


	public render() {
		let created = moment(new Date(this.props.data.created));
		let now = moment(new Date());

		return(
			<button
				onClick = {(e) => this.readNotification(e)}
				className={`list-group-item list-group-item-action ${styles.noBorder} ${this.displaAsyNew() ?
						styles.newNotification : ""}
				`}
				onMouseEnter = {() => this.reactToHover()} /* in case, that the user hoverd above the notification */
				//className={`list-group-item list-group-item-action ${styles.noBorder}`}
			>
				<div>
					<span className = {styles.headerNotification}>
						<FontAwesomeIcon icon = {this.props.data.sourceIcon}/>
						<span className = {`${styles.headerNotification}`}>
							{" " + this.props.data.sourceName} {this.displaAsyNew() ? " " : <span>{" "}&bull;{" "}</span>}
						</span>

						</span>
						{ /* in case, that the user hoverd above the notification */
							this.displaAsyNew() ?
								<span className="label label-success">new</span>
							:
								<small className = {styles.timer}>
									{created.from(now)}
								</small>
						}{this.isReadable() ?
						<OverlayTrigger placement = "right" overlay = {<Tooltip id = "tooltip">Mark as read</Tooltip>}>
							<span className = {styles.exitButton} onClick={(e) => this.markAsRead(e)}>
								<FontAwesomeIcon icon={faTimes} />
							</span>
						</OverlayTrigger> : <span/> }
						<hr className = {styles.hrNoti}/>
						<div className = {styles.notiTitle}>
							{this.props.data.title}
						</div>

					<span className = {styles.detail}>{this.props.data.content}</span>
				</div>
			</button>

		);
	}
}



// WEBPACK FOOTER //
// ./src/common/NotificationCenter/NotificationCenter.tsx